import React, { useState, useEffect } from 'react';
import { PropTypes } from 'prop-types';
import { Button } from 'react-style-guide';
import { DeviceMeta } from 'Roblox';
import PremiumConstants from '../constants/PremiumConstants';
import PremiumService from '../services/premiumService';

const { isInApp } = DeviceMeta();
function SubscriptionCard({ translate, intl, planInfo, userPlan }) {
  const [cardStatus, setCardStatus] = useState(null);

  const planTitle = translate('Label.PremiumPlanName', { type: planInfo.robuxAmount });
  const priceLabel = translate('Label.AmountPerMonth', {
    amount: `${planInfo.price.currency.currencySymbol}${planInfo.price.amount}`,
    subTextStart: '<span class="font-bold">',
    subTextEnd: '</span>'
  });

  const packageDescription = translate('Description.GetRobuxEachMonth', {
    robux: `<span class='icon-robux-16x16'></span><span>${planInfo.robuxAmount}</span>`
  });

  const onSubscribeButtonClick = () => {
    PremiumService.sendInteractionClickEvent(
      PremiumConstants.premiumFeatureType.robux,
      PremiumConstants.streamEventParams.buyBtn,
      planInfo.productId
    );
    if (!isInApp) {
      const buyUrl = PremiumService.getPaymentUrl(planInfo);
      window.location.href = buyUrl;
    }
  };

  useEffect(() => {
    const status = {
      dateString: '',
      cssClass: 'subscription-card',
      buttonLabelKey: 'Label.SubscribeNow',
      buttonDisabled: false
    };

    const getUserPlanDate = () => {
      return userPlan.renewal ? translate('Label.AutoRenewal') : translate('Label.CurrentPlan');
    };

    if (userPlan) {
      if (userPlan.premiumFeatureId === planInfo.premiumFeatureId) {
        status.dateString = getUserPlanDate();
        status.cssClass = 'subscription-card purchased';
        status.buttonLabelKey = 'Action.CurrentPlan';
        status.buttonDisabled = true;
      } else {
        status.cssClass = 'subscription-card disabled';
        status.buttonLabelKey = 'Action.NotAvailable';
        status.buttonDisabled = true;
      }
    }
    setCardStatus(status);
  }, [intl, planInfo.premiumFeatureId, translate, userPlan]);

  return (
    <div className='div-table-cell'>
      {cardStatus?.dateString && (
        <div className='font-header-2 plan-date'>{cardStatus.dateString}</div>
      )}
      <a
        href={cardStatus?.buttonDisabled === false && PremiumService.getPaymentUrl(planInfo)}
        className={cardStatus?.buttonDisabled && 'disabled'}
        onClick={onSubscribeButtonClick}>
        <div className={cardStatus?.cssClass}>
          <div className='medium-header plan-name'>{planTitle}</div>
          <div className='icon-premium-88x88' />
          <div className='subscription-price'>
            <div className='font-title'>
              <span dangerouslySetInnerHTML={{ __html: priceLabel }} />
            </div>
          </div>
          <div dangerouslySetInnerHTML={{ __html: packageDescription }} />
          <Button
            className='subscribe-button'
            variant={Button.variants.primary}
            width={Button.widths.min}
            size={Button.sizes.large}
            onClick={onSubscribeButtonClick}
            isDisabled={cardStatus?.buttonDisabled}>
            {cardStatus && translate(cardStatus.buttonLabelKey)}
          </Button>
        </div>
      </a>
    </div>
  );
}

SubscriptionCard.defaultProps = {
  userPlan: null
};

SubscriptionCard.propTypes = {
  translate: PropTypes.func.isRequired,
  intl: PropTypes.shape({
    d: PropTypes.func.isRequired
  }).isRequired,
  planInfo: PropTypes.shape({
    productId: PropTypes.number.isRequired,
    premiumFeatureId: PropTypes.number.isRequired,
    robuxAmount: PropTypes.string.isRequired,
    price: PropTypes.shape({
      amount: PropTypes.number.isRequired,
      currency: PropTypes.shape({
        currencySymbol: PropTypes.string.isRequired
      }).isRequired
    }).isRequired
  }).isRequired,
  userPlan: PropTypes.shape({
    premiumFeatureId: PropTypes.number.isRequired,
    subscriptionTypeName: PropTypes.string.isRequired,
    robuxStipendAmount: PropTypes.number.isRequired,
    isLifetime: PropTypes.bool.isRequired,
    expiration: PropTypes.string,
    renewal: PropTypes.string,
    created: PropTypes.string.isRequired,
    purchasePlatform: PropTypes.string.isRequired
  })
};

export default SubscriptionCard;
